import LOGO from '../../assets/images/logos/logo.png';
import textImg from '../../assets/images/logos/logo-text-black.png';
import React from 'react';
import { Link } from 'react-router-dom';
export default function Logo({ src = '', className = '', textOnly = false }) {
	return (
		<Link
			to={`/`}
			onClick={() => document.getElementById('root')?.scrollIntoView({ behavior: 'smooth' })}
		>
			<img
				id='logo'
				className={className ? className : `w-auto h-10`}
				src={src ? src : textOnly ? textImg : LOGO}
				alt='Logo'
			/>
		</Link>
	);
}
